"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesService = void 0;
var FilesService = /** @class */ (function () {
    function FilesService(httpClient, tokenManager) {
        this.httpClient = httpClient;
        this.tokenManager = tokenManager;
    }
    FilesService.prototype.upload = function (file) {
        var body = new FormData();
        body.append('file', file, file.name);
        return this.httpClient.post('files', body, this.getInit());
    };
    FilesService.prototype.uploadBulk = function (files) {
        var body = new FormData();
        files.forEach(function (file) { return body.append('files[]', file, file.name); });
        return this.httpClient.post('files/bulk', body, this.getInit());
    };
    FilesService.prototype.getInit = function () {
        var headers = {};
        var token = this.tokenManager.getToken();
        if (token) {
            headers.Authorization = "Bearer " + token;
        }
        return { headers: headers };
    };
    return FilesService;
}());
exports.FilesService = FilesService;
